import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function CallLogs() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Call Logs
      </Typography>
      <Paper sx={{ p: 4, mt: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Call logs page - Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
}
